/**
 * External dependencies
 */
import React from 'react';
import page from 'page';

/**
 * Internal dependencies
 */
import { getConnection } from 'state/connections/selectors';
import EditConnection from './edit/main';
import Operations from './operations/main';
import Locations from './locations/main';
import Tools from './tools/main';
import Preferences from './preferences/main';
import Resources from './resources/main';
import Sales from './sales/main';
import Images from './images/main';
import TestMain from './test/main';

export const tools = (context, next) => {
    const connectionId = context.params.connectionId;
    const state = context.store.getState();
    context.primary = <Tools connectionId={connectionId} />;
    next();
};

export const preferences = (context, next) => {
    const connectionId = context.params.connectionId;
    const state = context.store.getState();
    context.primary = <Preferences connectionId={connectionId} />;
    next();
};

export const locations = (context, next) => {
    const connectionId = context.params.connectionId;
    const state = context.store.getState();
    context.primary = <Locations connectionId={connectionId} />;
    next();
};

export const operations = (context, next) => {
    const connectionId = context.params.connectionId;
    const state = context.store.getState();
    context.primary = <Operations connectionId={connectionId} />;
    next();
};

export const resources = (context, next) => {
    const connectionId = context.params.connectionId;
    const state = context.store.getState();
    context.primary = <Resources connectionId={connectionId} />;
    next();
}

export const edit = (context, next) => {
    const connectionId = context.params.connectionId;
    const state = context.store.getState();
    context.primary = <EditConnection connectionId={connectionId} />;
    next();
};

export const sales = (context, next) => {
    const connectionId = context.params.connectionId;
    const state = context.store.getState();
    context.primary = <Sales connectionId={connectionId} />;
    next();
};

export const images = (context, next) => {
    const connectionId = context.params.connectionId;
    const state = context.store.getState();
    context.primary = <Images connectionId={connectionId} />;
    next();
};

/**
 * Testing
 */
export const test = (context, next) => {
    const connectionId = context.params.connectionId;
    const state = context.store.getState();
    context.primary = <TestMain connectionId={connectionId} />;
    next();
};